function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import classnames from "classnames";
import { StyledBlogCardItemFooterComponent } from "./blog-card-item-footer-component.scss";
import PictureComponent from "components/core/picture/picture-component";
import LinkedinIcon from "static/svg/linkedin2.svg";
import FacebookIcon from "static/svg/facebook2.svg";
import TwitterIcon from "static/svg/twitter2.svg";
import SocialIconLinkComponent from "./social-icon-link/social-icon-link-component";
const SOCIAL_LINKS = [
    {
        icon: LinkedinIcon,
        color: "#006699"
    },
    {
        icon: FacebookIcon,
        color: "#4B69B0"
    },
    {
        icon: TwitterIcon,
        color: "1DA1F2"
    }
];
class BlogCardItemFooterComponent extends PureComponent {
    renderSocialLinks() {
        return SOCIAL_LINKS.map((socialLink, index)=>{
            return /*#__PURE__*/ _jsx("div", {
                className: "social-icon-link-component-wrapper",
                children: /*#__PURE__*/ _jsx(SocialIconLinkComponent, _object_spread({}, socialLink))
            }, index);
        });
    }
    render() {
        const { isCardHoverd, writerImageSrc, writerName, articleDate, minutesToRead } = this.props;
        return /*#__PURE__*/ _jsxs(StyledBlogCardItemFooterComponent, {
            className: "blog-card-item-footer-component",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "picture-component-wrapper",
                    children: /*#__PURE__*/ _jsx(PictureComponent, {
                        src: writerImageSrc
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "blog-footer-details",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "writer-name",
                            children: writerName
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "more-details",
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "article-date",
                                    children: articleDate
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "seperated-dot"
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "minutes-to-read",
                                    children: minutesToRead
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: classnames("social-links", {
                        show: isCardHoverd
                    }),
                    children: this.renderSocialLinks()
                })
            ]
        });
    }
}
export { BlogCardItemFooterComponent as default };
